// extracted by mini-css-extract-plugin
export default {"popups-root":"uMRph1","popupsRoot":"uMRph1","popups-wrapper":"_78sYET","popupsWrapper":"_78sYET"};